module.exports = __webpack_public_path__ + "img/21.e26d4824.jpg";